import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteDisplayDeviceSlice = createSlice({
  name: 'DeleteDisplayDevice',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteDisplayDevice: (state, _) => {
      state.isLoading = true;
    },
    successDeleteDisplayDevice: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteDisplayDevice: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteDisplayDevice: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteDisplayDevice,
  successDeleteDisplayDevice,
  failureDeleteDisplayDevice,
  clearDeleteDisplayDevice,
} = DeleteDisplayDeviceSlice.actions;

export default DeleteDisplayDeviceSlice.reducer;
